import React from "react";
import { LoadingContainer } from "./style";
const Loading = () => {
  return (
    <LoadingContainer>
      <div className="text">لطفا کمی صبر کنید ...</div>
    </LoadingContainer>
  );
};
export default Loading;
